import TextDivider from 'components/atoms/TextDivider'
import i18n from 'utils/i18n'
import RenderEmployeeList from 'scenes/home/book/_functions/EmployeeRenders'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import EmployeeStatusTag from 'scenes/home/book/validate/_components/EmployeeStatusTag'
import _ from 'lodash'
import HelperCart from 'utils/helper-cart'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { colorList } from 'utils/colors'
import { cartConstants } from 'services/redux/cart/constants'
import { EmployeeCardShowBasic } from 'components/molecules/EmployeeCard'
import HelperPlatform from 'utils/helper-platform'
import { layoutStyles } from 'styles/layout'

const EmployeeBlock = ({ onPress, status, bookForOption }) => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const _bookingExternalPersons = useSelector( state => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	} );
	const _cartBookingCoworkers = useSelector( state => {
		return state.cart[cartConstants.BOOKING_COWORKERS];
	} );
	
	let content = [];
	
	
	
	if( !HelperCart.bookingForOthers() ){
		let employees = {};
		employees[ _employee.guid ] = { ..._employee, ...{readOnly: true } };
		
		content.push(
			<RenderEmployeeList
				containerStyle={ layoutStyles.flexUnset }
				employees={ employees }
				showSelf={ true }
				show={ EmployeeCardShowBasic }
			/>
		);
	}
	
	if( _.size( _cartBookingCoworkers ) > 0 ){
		let employees = {};
		_.forEach( _cartBookingCoworkers, ( employee ) => {
			employees[ employee.guid ] = { ...employee, ...{readOnly: true } };
		});
		
		content.push(
			<>
				<TextDivider key={ 'coworkers' }  text={ i18n.t( 'page.create.coworker.mode_co_workers') } />
			</>
		);
		
		content.push(
			<RenderEmployeeList
				containerStyle={ layoutStyles.flexUnset }
				employees={ employees }
				showSelf={ true }
				onPressEmployee={ onPress }
				show={ employee => {
					return (
						<EmployeeStatusTag
							employee={ employee }
							employeeStatus={ status }
						/>
					);
				}}
			/>
		);
	}
	
	if( _.size( _bookingExternalPersons ) > 0 ){
		let employees = {};
		_.forEach( _bookingExternalPersons, ( employee ) => {
			employees[ employee.guid ] = { ...employee, ...{readOnly: true } };
		});
		
		content.push(
			<TextDivider key={ 'external_relations' }  text={ i18n.t( 'page.create.coworker.mode_external') } />
		);
		
		content.push(
			<RenderEmployeeList
				containerStyle={ layoutStyles.flexUnset }
				employees={ employees }
				showSelf={ true }
				onPressEmployee={ onPress }
				show={ employee => {
					return (
						<EmployeeStatusTag
							employee={ employee }
							employeeStatus={ status }
						/>
					);
				}}
			/>
		);
	}
	
	return (
		<View>
			
			{ content }
		</View>
	)
}

const styles = StyleSheet.create( {
	userDescriptionHint: {
		margin: 12,
		color: colorList.TEXT_HINT.primary,
		fontSize: 12,
		fontStyle: 'italic',
		textAlign: 'center',
	},
})

export default EmployeeBlock
